import { lazy } from "react";
import Loadable from "../../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../../constants/enums";
import { BUSINESS_ATTACHMENT_LIST } from "../../Business.constants";

const BusinessAttachmentList = Loadable(
  lazy(() =>
    import("./AttachmentList").then(({ BusinessAttachmentList }) => ({
      default: BusinessAttachmentList,
    }))
  )
);
export const AttachmentsRoutes = [
  {
    path: `${BUSINESS_ATTACHMENT_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessAttachmentList />
      </AuthorizedRoute>
    ),
  },
];
